import { ActionTypes } from "../constants/action-types";
const initialState = {
};


export function filterReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ActionTypes.SET_ACTIVITY_FILTER:
            return { ...state, activityFilter: payload };
        case ActionTypes.SET_ACTIVITY_SCHEDULED_FILTER:
            return { ...state, activityScheduledFilter: payload };
        case ActionTypes.SET_JOBSITE_FILTER:
            return { ...state, jobsiteFilter: payload };
        default:
            return state;
    }
}